// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 20) return "static/js/a7067d88d0c896808d36.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"78efbf73eb70774860fc","118":"fd2704454f7637af9123","119":"7aec53f305401ad2a9dd"}[chunkId] + ".chunk.js";
};